/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
/**
 * 
 * @export
 * @interface SubscriberInfo
 */
export interface SubscriberInfo {
    /**
     * 
     */
    memberIdentifier: string;
    /**
     * 
     */
    firstName: string;
    /**
     * 
     */
    lastName: string;
    /**
     * Date in YYYY-MM-DD format
     */
    dateOfBirth: Date;
}

/**
 * Check if a given object implements the SubscriberInfo interface.
 */
export function instanceOfSubscriberInfo(value: object): value is SubscriberInfo {
    if (!('memberIdentifier' in value) || value['memberIdentifier'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('dateOfBirth' in value) || value['dateOfBirth'] === undefined) return false;
    return true;
}

export function SubscriberInfoFromJSON(json: any): SubscriberInfo {
    return SubscriberInfoFromJSONTyped(json, false);
}

export function SubscriberInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubscriberInfo {
    if (json == null) {
        return json;
    }
    return {
        
        'memberIdentifier': json['memberIdentifier'],
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'dateOfBirth': (json['dateOfBirth'] == null ? json['dateOfBirth'] : parseDate(json['dateOfBirth'])),
    };
}

export function SubscriberInfoToJSON(json: any): SubscriberInfo {
    return SubscriberInfoToJSONTyped(json, false);
}

export function SubscriberInfoToJSONTyped(value?: SubscriberInfo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'memberIdentifier': value['memberIdentifier'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'dateOfBirth': value['dateOfBirth'] == null ? value['dateOfBirth'] : serializeDate(value['dateOfBirth']),
    };
}

